import React from 'react';
import { config } from '@abyss/web/tools/config';
import { Router } from '@abyss/web/ui/Router';
import { PortalData, PortalName } from '@/common/DataModel/PortalData';
import { useRouter } from '@abyss/web/hooks/useRouter';
import { useGetThemePortalProps } from '@/hooks/useGetThemePortalProps';
import { createThemeOverride } from '@/style/theme';
import { MockAuthPcpDisabledPortalMemberInfo } from '@/common/DataModel/MockAuthMember';
import {
  getSearchParamsOrFromStorage,
  PSXBlueGreenCanaryGraphqlApi,
} from '../../utils/utils';
import { StoreKeys } from '@/common/constants';
import {
  EmptySSOPortalEligibilityData,
  SSOPortalEligibilityData,
} from 'api/src/dataModels/SSOPortalEligibilityData';
import { useSessionStorage } from 'usehooks-ts';
import { useLanguage } from '../../components/Language/LanguageProvider';
import 'mapbox-gl/dist/mapbox-gl.css';

export const FindCare = () => {
  const { getSearchParams } = useRouter();
  const [searchParams] = getSearchParams();
  const { locale } = useLanguage();

  const graphqlUrl = PSXBlueGreenCanaryGraphqlApi();

  const enablePreProd =
    getSearchParamsOrFromStorage(searchParams, 'usePreProd') === 'true';

  const [ssoPortalEligibilityData] =
    useSessionStorage<SSOPortalEligibilityData>(
      StoreKeys.SSO_PORTAL_ELIGIBILITY_DATA,
      EmptySSOPortalEligibilityData
    );

  const { portalTheme } = useGetThemePortalProps();
  const themeOverride = createThemeOverride(portalTheme);

  const portalData: PortalData = {
    portalName: ssoPortalEligibilityData.portalSource as unknown as PortalName,
    portalIdentifier: ssoPortalEligibilityData.portalIdentifier,
    portalConfig: {
      basePath: '/findcare',
      graphQlUrl: graphqlUrl,
      mapLocationUrl: config('PSX_MAP_LOCATION_API_URL'),
      headerChipsEnabled: true,
      theme: 'uhc',
      themeOverride,
      language: locale.locale,
      homePage: '/',
      isGuestUser: false,
      includeBaseCss: false,
      useOBAPI: true,
      loadAdobeScript: false,
    },
  };

  if (!ssoPortalEligibilityData.isFakeUser) {
    portalData.portalEligibilityData = ssoPortalEligibilityData;
    portalData.portalEligibilityData.useObapiPreprod = enablePreProd;
  } else {
    portalData.portalConfig.useOBAPI = false;
    portalData.portalMemberInfo = MockAuthPcpDisabledPortalMemberInfo;
  }

  return (
    <React.Fragment>
      <Router.MetaTags title="Find Care" />
      <abyss-parcel
        import="provider-search-for-portal"
        portal-data={JSON.stringify(portalData)}
      />
    </React.Fragment>
  );
};
